import React from 'react'
import { useWorkspace } from '../WorkspaceContext'
import styles from './uimodetoggle.module.scss'

const UiModeToggle = () => {
    const { uiMode, setUiMode } = useWorkspace();

    const changeUiMode = (mode: 'editor' | 'files') => {
        localStorage.setItem('flashroom-ui-mode', mode);
        setUiMode(mode);
    };

    return (
        <div className={styles.uiModeToggle}>
            <button
                type='button'
                className={`${styles.uiModeBtn} ${uiMode === 'editor' ? styles.uiModeBtnActive : ''}`}
                onClick={() => changeUiMode('editor')}
            >
                <img draggable={false} className='no-select' src={`${process.env.PUBLIC_URL}/images/edit-icon-sb.png`} alt='' />
                <span>Workspace</span>
            </button>
            <button
                type='button'
                className={`${styles.uiModeBtn} ${uiMode === 'files' ? styles.uiModeBtnActive : ''}`}
                onClick={() => changeUiMode('files')}
            >
                <img draggable={false} className='no-select' src={`${process.env.PUBLIC_URL}/images/folder-icon-sidebar.png`} alt='' />
                <span>Drive</span>
            </button>
        </div>
    )
}

export default UiModeToggle
